import { FormikInput } from 'shared/components/FormikInput';
import styled, { css } from 'styled-components';

import { FieldType } from 'checkout/enums/FieldType';
import { ADDRESS_FIELD_TYPE_MAP } from 'checkout/enums/address';

interface IAddressTextFieldProps {
  className?: string;
  disabled?: boolean;
  label: string;
  name: string;
  'data-qa'?: string;
  type: FieldType;
}

export const AddressTextField = ({
  className,
  disabled,
  label,
  name,
  type,
  ...props
}: IAddressTextFieldProps) => {
  const inputProps = ADDRESS_FIELD_TYPE_MAP[type];

  return (
    <AddressTextField.Input
      className={className}
      label={label}
      name={name}
      data-qa={props['data-qa']}
      disabled={disabled}
      {...inputProps}
    />
  );
};

AddressTextField.Input = styled(FormikInput)`
  ${({ theme }) => css`
    color: ${theme.colors.black};
  `}
`;
